'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import { FOCUS_RING } from '@common/components/interaction';
import { cn } from '@core/utils';
import { TrendKeywordPanel } from './TrendKeywordPanel';
import { TrendKeywordToggle } from './TrendKeywordToggle';
import { TrendKeywordTrack } from './TrendKeywordTrack';
import { useTrendKeyword } from './useTrendKeyword';
export const TrendKeywordBar = () => {
  const $ = _c(30);
  const {
    keywords,
    step,
    isOpen,
    isPending,
    currentKeyword,
    search,
    toggle
  } = useTrendKeyword();
  if (!isPending && !currentKeyword) {
    return null;
  }
  let t0;
  bb0: {
    if (!currentKeyword) {
      let t1;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = <span className="flex h-36 min-w-0 flex-1 items-center"><Skeleton typo="body4" className="w-140 rounded-xsmall" /></span>;
        $[0] = t1;
      } else {
        t1 = $[0];
      }
      t0 = t1;
      break bb0;
    }
    if (isOpen) {
      let t1;
      if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = <span className="flex h-36 min-w-0 flex-1 items-center font-600 text-Gray-900 typo-body4">웰로 키워드</span>;
        $[1] = t1;
      } else {
        t1 = $[1];
      }
      t0 = t1;
      break bb0;
    }
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = cn("flex h-36 min-w-0 flex-1 animate-fade items-center rounded-xsmall motion-reduce:animate-none", "transition-colors duration-150 active:bg-Gray-100 motion-reduce:transition-none", FOCUS_RING);
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    const t2 = `${currentKeyword.ranking}위 ${currentKeyword.keyword} 검색`;
    let t3;
    if ($[3] !== currentKeyword.keyword || $[4] !== search) {
      t3 = () => search(currentKeyword.keyword);
      $[3] = currentKeyword.keyword;
      $[4] = search;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== keywords || $[7] !== step) {
      t4 = <TrendKeywordTrack keywords={keywords} step={step} size="mobile" />;
      $[6] = keywords;
      $[7] = step;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
      t5 = <button className={t1} aria-label={t2} onClick={t3}>{t4}</button>;
      $[9] = t2;
      $[10] = t3;
      $[11] = t4;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t0 = t5;
  }
  const keywordSlot = t0;
  const t1 = !isOpen && "rounded-b-large shadow-[0px_8px_9px_0px_rgba(0,0,0,0.04)]";
  let t2;
  if ($[13] !== t1) {
    t2 = cn("relative flex min-h-50 w-full items-center gap-8 bg-Gray-white pl-24 pr-12", t1);
    $[13] = t1;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] !== currentKeyword || $[16] !== isOpen || $[17] !== toggle) {
    t3 = currentKeyword && <TrendKeywordToggle isOpen={isOpen} onToggle={toggle} />;
    $[15] = currentKeyword;
    $[16] = isOpen;
    $[17] = toggle;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  let t4;
  if ($[19] !== keywordSlot || $[20] !== t2 || $[21] !== t3) {
    t4 = <div className={t2}>{keywordSlot}{t3}</div>;
    $[19] = keywordSlot;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  let t5;
  if ($[23] !== isOpen || $[24] !== keywords || $[25] !== search) {
    t5 = isOpen && <TrendKeywordPanel keywords={keywords} onSelect={search} size="mobile" className="absolute inset-x-0 top-full z-10 max-h-[min(520px,calc(100dvh-98px))] overflow-y-auto rounded-b-large bg-Gray-white px-16 py-8 shadow-[0px_8px_9px_0px_rgba(0,0,0,0.04)]" />;
    $[23] = isOpen;
    $[24] = keywords;
    $[25] = search;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  let t6;
  if ($[27] !== t4 || $[28] !== t5) {
    t6 = <div className="relative bg-Gray-white">{t4}{t5}</div>;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  return t6;
};